export const API_ENDPOINT ="https://api.giphy.com/v1/gifs";

export const API_KEY =process.env.REACT_APP_GIPHYAPI_KEY;

export const API_ENDPOINT2 = "https://api.unsplash.com"

export const CLIENT_ID = process.env.REACT_APP_UNSPLASH_KEY;